module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Text copyright © 2017 by Jill O’Connor.")]), _vm._v(" "), _c('p', [_vm._v("Photographs copyright © 2017 by Leigh Beisch.")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 9781452153940 (epub, mobi)")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data:")]), _vm._v(" "), _c('p', [_vm._v("Names: O’Connor, Jill, author."), _c('br'), _vm._v("Title: Cake, I love you : decadent, delectable, and do-able recipes / Jill O’Connor."), _c('br'), _vm._v("Description: San Francisco : Chronicle Books, 2017. | Includes index."), _c('br'), _vm._v("Identifiers: LCCN 2016025898 | ISBN 9781452153803 (hardback)"), _c('br'), _vm._v("Subjects: LCSH: Cake. | BISAC: COOKING / Methods / Baking. | COOKING / Courses & Dishes / Cakes. | LCGFT: Cookbooks."), _c('br'), _vm._v("Classification: LCC TX771.O29 2017 | DDC 641.86/53—dc23 LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2016025898",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2016025898")])]), _vm._v(" "), _c('p', [_vm._v("Designed by Alice Chau."), _c('br'), _vm._v("Illustrations by Jordan Sondler.")]), _vm._v(" "), _c('p', [_vm._v("Food styling by Robyn Valarik."), _c('br'), _vm._v("Prop styling by Sara Slavin.")]), _vm._v(" "), _c('p', [_vm._v("Chronicle books and gifts are available at special quantity discounts to corporations, professional associations, literacy programs, and other organizations. For details and discount information, please contact our premiums department at "), _c('a', {
    attrs: {
      "href": "mailto:corporatesales@chroniclebooks.com"
    }
  }, [_vm._v("corporatesales@chroniclebooks.com")]), _vm._v(" or at 1-800-759-0190.")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725bdf56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04copyright.vue
// module id = 66
// module chunks = 0